import { EssentialsService } from "@3gaam/api/services";
import {
  EssentialsOutput,
  OptionsQueryOutput,
  OptionPortable,
} from "@3gaam/api/types/essentials";

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { paginationThunk } from "@3gaam/shared/hooks/useQuery";
import { OptionsQueryInput } from "@3gaam/api/types/essentialsMapped";

export const essentialsAction = createAsyncThunk(
  "essentials/essentials",
  async (payload: string, thunkAPI) => {
    const res = await EssentialsService.essentials(payload);
    return res.data;
  },
);

export const optionsQueryAction = createAsyncThunk(
  "essentials/optionsQuery",
  async (payload: OptionsQueryInput, thunkAPI) => {
    const res = await paginationThunk<OptionsQueryInput, OptionPortable, OptionsQueryOutput>(EssentialsService.optionsQuery, payload);
    return res.data;
  },
);

interface WithLoadingState<T> {
  success: boolean;
  requesting: boolean;
  error: boolean;
  data?: T;
}

export interface EssentialsState {
  essentials?: WithLoadingState<EssentialsOutput>;
  optionsQuery?: WithLoadingState<OptionsQueryOutput>;
}

const initialState: EssentialsState = {
  essentials: { success: false, error: false, requesting: false },
  optionsQuery: { success: false, error: false, requesting: false },
};

export const essentialsSlice = createSlice({
  name: "essentials",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(essentialsAction.pending, (state, action) => {
        state.essentials = {
          ...state.essentials,
          success: false,
          requesting: true,
          error: false,
        };
      })
      .addCase(essentialsAction.fulfilled, (state, action) => {
        state.essentials = {
          success: true,
          requesting: false,
          error: false,
          data: action.payload,
        };
      })
      .addCase(essentialsAction.rejected, (state, action) => {
        state.essentials = {
          ...state.essentials,
          success: false,
          requesting: false,
          error: true,
        };
      })
      .addCase(optionsQueryAction.pending, (state, action) => {
        state.optionsQuery = {
          ...state.optionsQuery,
          success: false,
          requesting: true,
          error: false,
        };
      })
      .addCase(optionsQueryAction.fulfilled, (state, action) => {
        state.optionsQuery = {
          success: true,
          requesting: false,
          error: false,
          data: action.payload,
        };
      })
      .addCase(optionsQueryAction.rejected, (state, action) => {
        state.optionsQuery = {
          ...state.optionsQuery,
          success: false,
          requesting: false,
          error: true,
        };
      });
  },
});

export default essentialsSlice.reducer;
